import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import "./styles.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root introuvable dans index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
